import { HStack, Icon, StackProps, useColorModeValue } from "@chakra-ui/react";
import { FaDollarSign } from "react-icons/fa";

interface Props extends StackProps {
  defaultValue?: number;
  max?: number;
  size?: "sm" | "md" | "lg" | "xl";
}

export const PriceReviewTag = (props: Props) => {
  const { defaultValue = 0, max = 3, size = "md", ...rootProps } = props;
  const color = useColorModeValue("gray.200", "gray.600");
  const activeColor = useColorModeValue("green.500", "green.200");
  return (
    <HStack spacing="-1" alignItems="center" {...rootProps}>
      {Array.from({ length: max })
        .map((_, index) => index + 1)
        .map((index) => (
          <Icon
            key={index}
            as={FaDollarSign}
            fontSize={size}
            color={index <= defaultValue ? activeColor : color}
          />
        ))}
    </HStack>
  );
};
